import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-notfound',
    templateUrl: './notfound.component.html',
})
export class NotfoundComponent { }